
const InstructionsTab = ({ instructions, onUpdateInstruction }) => {
  return (
    <div>
      {instructions && instructions.length > 0 ? (
        <div className="space-y-4">
          {instructions.map((instruction, index) => (
            <div key={index} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
              <div className="flex justify-between items-center mb-3">
                <h3 className="text-sm font-semibold text-gray-600">Instruction: {instruction.type}</h3>
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-medium mb-2">Type</label>
                <input
                  type="text"
                  className="border border-gray-200 rounded w-full py-2 px-3 text-gray-700 bg-gray-100 focus:outline-none"
                  value={instruction.type}
                  readOnly
                />
              </div>

              <div>
                <label className="block text-gray-700 text-sm font-medium mb-2">Content</label>
                <textarea
                  className="border border-gray-200 rounded w-full py-2 px-3 text-gray-700 focus:outline-none font-mono"
                  rows={10}
                  value={instruction.content}
                  onChange={(e) => onUpdateInstruction(index, 'content', e.target.value)}
                  placeholder="Enter instruction content..."
                />
                <p className="text-gray-400 text-xs mt-1">
                  This content will be used to guide the LLM's behavior.
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-gray-500">No instructions configured</p>
          <p className="text-sm text-gray-400 mt-2">
            Instructions help guide the LLM's behavior and responses.
          </p>
        </div>
      )}
    </div>
  );
};

export default InstructionsTab;
